import { SearchResult } from '@mews-commander/types';
import { Link } from '@optimus-web/core';
import { Target } from '@mews/enums';
import { SEARCH_TYPE_ICON_MAP } from '../constants';

export const SearchResultSuffix = ({ searchResult }: { searchResult?: SearchResult | null }) => {
    if (!searchResult) {
        return null;
    }

    const { searchType, url } = searchResult;
    const icon = SEARCH_TYPE_ICON_MAP[searchType];

    if (!icon || !url) {
        return null;
    }

    return <Link target={Target.Blank} icon={icon} href={url} variant="basic" />;
};
